<template>
  <div>
    <tiger-category-strip name="ウォレット振替のご案内" :items="categoryLinks" />

    <section id="swap-1" class="panel">
      <h2>ウォレット振替（スワップ機能）の利用</h2>
      <div class="bodytext" v-text="'「ウォレット振替」では、ウォレット間の残高移行や、保有している仮想通貨を対応する別の仮想通貨へ交換できます。\n\n例：USDT → BTC、ETH、SOLなど'" />
      <div class="panel-shots">
        <div class="screenshot-grid one">
          <tiger-shot src="sup/help/swap_1.webp" />
        </div>
      </div>
    </section>

    <section id="swap-2" class="panel">
      <h2>ボーナスを出金する場合</h2>
      <div class="bodytext" v-text="'・ボーナスの賭け条件・出金条件を達成しても、自動でリアルマネーには移行されません。\n\n・出金するには、「ウォレット振替」からボーナスウォレットの残高をご自身でメインウォレットまたは対応する仮想通貨ウォレットへ移行してください。\n\n・その後、移行先のウォレットから出金申請を行ってください。\n\n※条件を達成していないボーナスは、出金可能なウォレットへ移行できません。'" />
      <div class="panel-shots">
        <div class="screenshot-grid one">
          <tiger-shot src="sup/help/swap_2.webp" />
        </div>
        <p id="swap-3" class="shot-caption">
          ※画像スワップ例：出金条件クリアされたボーナスをUSDTに移行
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import TigerCategoryStrip from './tigerCategoryStrip.vue'
import TigerShot from './tigerShot.vue'

const categoryLinks = [
  { id: 'swap-1', label: 'ウォレット振替（スワップ機能）の利用' },
  { id: 'swap-2', label: 'ボーナスを出金する場合' },
  { id: 'swap-3', label: '出金条件達成後のスワップ例' }
]

export default {
  name: 'TigerSwap',
  components: {
    TigerCategoryStrip,
    TigerShot
  },
  data() {
    return {
      categoryLinks
    }
  }
}
</script>
